import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';
import { REBelegart } from '../Enums/REBelegart.enum';

import { BankDetails } from './BankDetails.entity';
import { Currency } from './Currency.entity';
import { FavoriteItem } from './FavoriteItem.entity';
import { File } from './File.entity';
import { InboundDeliveryNote } from './InboundDeliveryNote.entity';
import { InboundInvoicePayment } from './InboundInvoicePayment.entity';
import { Order } from './Order.entity';
import { PaymentKind } from './PaymentKind.entity';
import { Project } from './Project.entity';
import { RELedgerAccountSplit } from './RELedgerAccountSplit.entity';
import { SumValues } from './SumValues.entity';
import { Supplier } from './Supplier.entity';
import { User } from './User.entity';

export class InboundInvoice<T extends EMode = EMode.entity> {
  /** Alias: bankkontoCode */
  bankAccountId?: number;
  /** Alias: bankverbindungCode */
  bankDetailsId?: number;
  /** Alias: belegart */
  invoiceKind?: REBelegart;
  /** Alias: benutzer */
  user?: User<T>;
  /** Alias: benutzerCode */
  userId?: number;
  /** Alias: bezahltSumme */
  amountGross?: number;
  /** Alias: buchungen */
  bookings?: RELedgerAccountSplit<T>[];
  /** Alias: buchungsDatum */
  bookingDate?: string;
  /** Alias: code */
  id?: number;
  /** Alias: creationDate */
  creationDate?: string;
  /** Alias: dMSDokumentenID */
  dMSDocumentId?: string;
  /** Alias: dTANr */
  dTANr?: number;
  /** Alias: datev */
  datevDate?: string;
  /** Alias: datum */
  invoiceDate?: string;
  /** Alias: editBenutzerCode */
  editUserId?: number;
  /** Alias: editDate */
  editDate?: string;
  /** Alias: eingangsDatum */
  dateOfReceipt?: string;
  /** Alias: eingangslieferscheinCode */
  inboundDeliveryNoteId?: number;
  /** Alias: faelligDatum */
  dueDate?: string;
  /** Alias: frei1 */
  free1?: number;
  /** Alias: freigabeBCode */
  releasedByUserId?: number;
  /** Alias: freigabeDatum */
  releaseDate?: string;
  /** Alias: freigabeNotiz */
  releaseNote?: string;
  /** Alias: genehmigungDurchBCode */
  approvedByUserId?: number;
  /** Alias: kostenstelle */
  costCenterId?: number;
  /** Alias: kurs */
  course?: number;
  /** Alias: lieferant */
  supplier?: Supplier<T>;
  /** Alias: lieferdatum */
  deliveryDate?: string;
  /** Alias: lieferdatumGeplant */
  plannedDeliveryDate?: string;
  /** Alias: mahnstuffe */
  warningLevel?: number;
  /** Alias: notiz */
  note?: string;
  /** Alias: objGrCode */
  objGrId?: number;
  /** Alias: positionstext */
  positionText?: string;
  /** Alias: projektCode */
  projectId?: number;
  /** Alias: rBetrag */
  netValue?: number;
  /** Alias: rBetragErstellt */
  rAmountCreated?: number;
  /** Alias: rBetragFremd */
  rAmountForeign?: number;
  /** Alias: rESachkGesamt */
  rLedgerAccountTotal?: number;
  /** Alias: rMwst */
  valueVat?: number;
  /** Alias: rMwstErstellt */
  rVatCreated?: number;
  /** Alias: rNettoErstellt */
  rNetCreated?: number;
  /** Alias: rNummer */
  invoiceNumber?: number;
  /** Alias: rNummerbeiLieferant */
  originalInvoiceNumber?: string;
  /** Alias: referenz */
  reference?: string;
  /** Alias: reisekostenabrechnung */
  travelExpensesId?: number;
  /** Alias: sDObjMemberCode */
  businessPartnerId?: number;
  /** Alias: skonto */
  deductionDiscount?: number;
  /** Alias: skonto2 */
  discount2?: number;
  /** Alias: skonto2Datum */
  discount2Date?: string;
  /** Alias: skonto2Tg */
  discount2Days?: number;
  /** Alias: skontoDatum */
  discountDate?: string;
  /** Alias: skontoProzent */
  discountPerCent?: number;
  /** Alias: skontoTg */
  discountDays?: number;
  /** Alias: sperrungBcode */
  blockedByUserId?: number;
  /** Alias: statusCode */
  statusId?: number;
  /** Alias: stornSumme */
  cancellationSum?: number;
  /** Alias: summe */
  valueNotPayed?: number;
  /** Alias: templatename */
  templateName?: string;
  /** Alias: tmpSkonto */
  tmpSkonto?: number;
  /** Alias: ursprungBezSumme */
  originRelationSum?: number;
  /** Alias: ursprungMwst */
  originVat?: number;
  /** Alias: ursprungRBetrag */
  originRAmount?: number;
  /** Alias: verrechnetCode */
  calculatedCode?: number;
  /** Alias: waehrungCode */
  currencyId?: number;
  /** Alias: wiederkehrend */
  reoccuring?: number;
  /** Alias: zahlungsCode */
  paymentId?: number;
  /** Alias: zahlungsart */
  paymentKind?: PaymentKind<T>;
  /** Alias: genehmigungDurchBenutzer */
  approvedByUser?: User<T>;
  /** Alias: waehrung */
  currency?: Currency<T>;
  /** Alias: insertTime */
  insertTime?: string;
  /** Alias: updateTime */
  updateTime?: string;
  /** Alias: belege */
  receipts?: File<T>[];
  /** Alias: bankverbindung */
  bankAccount?: BankDetails<T>;
  /** Alias: freigabeDurchBenutzer */
  releasedByUser?: User<T>;
  /** Alias: eingangslieferscheine */
  inboundDeliveryNotes?: InboundDeliveryNote<T>[];
  /** Alias: bestellungen */
  orders?: Order<T>[];
  /** Alias: blockedByUser */
  blockedByUser?: User<T>;
  /** Alias: sumValues */
  sumValues?: SumValues<T>;
  /** Alias: paymentTermDays */
  paymentTermDays?: number;
  /** Alias: createdByUserCode */
  createdByUserCode?: number;
  /** Alias: createdByUser */
  createdByUser?: User<T>;
  /** Alias: paid */
  isPayed?: boolean;
  /** Alias: payments */
  payments?: InboundInvoicePayment<T>[];
  /** Alias: remainingAmount */
  remainingAmount?: number;
  /** Alias: grossAmount */
  grossAmount?: number;
  /** Alias: projekt */
  project?: Project<T>;
  /** Alias: expectedNumber */
  expectedNumber?: number;
  /** Alias: favoriteItem */
  favoriteItem?: FavoriteItem<T>;

  __typename?: string;
}

const fields: FieldDefinitions<InboundInvoice> = {
  bankAccountId: {
    alias: 'bankkontoCode',
  },
  bankDetailsId: {
    alias: 'bankverbindungCode',
  },
  invoiceKind: {
    alias: 'belegart',
  },
  user: {
    alias: 'benutzer',
    entity: Entities.user,
  },
  userId: {
    alias: 'benutzerCode',
  },
  amountGross: {
    alias: 'bezahltSumme',
  },
  bookings: {
    alias: 'buchungen',
    entity: Entities.rELedgerAccountSplit,
  },
  bookingDate: {
    alias: 'buchungsDatum',
  },
  id: {
    alias: 'code',
  },
  creationDate: {
    alias: 'creationDate',
  },
  dMSDocumentId: {
    alias: 'dMSDokumentenID',
  },
  dTANr: {
    alias: 'dTANr',
  },
  datevDate: {
    alias: 'datev',
  },
  invoiceDate: {
    alias: 'datum',
  },
  editUserId: {
    alias: 'editBenutzerCode',
  },
  editDate: {
    alias: 'editDate',
  },
  dateOfReceipt: {
    alias: 'eingangsDatum',
  },
  inboundDeliveryNoteId: {
    alias: 'eingangslieferscheinCode',
  },
  dueDate: {
    alias: 'faelligDatum',
  },
  free1: {
    alias: 'frei1',
  },
  releasedByUserId: {
    alias: 'freigabeBCode',
  },
  releaseDate: {
    alias: 'freigabeDatum',
  },
  releaseNote: {
    alias: 'freigabeNotiz',
  },
  approvedByUserId: {
    alias: 'genehmigungDurchBCode',
  },
  costCenterId: {
    alias: 'kostenstelle',
  },
  course: {
    alias: 'kurs',
  },
  supplier: {
    alias: 'lieferant',
    entity: Entities.supplier,
  },
  deliveryDate: {
    alias: 'lieferdatum',
  },
  plannedDeliveryDate: {
    alias: 'lieferdatumGeplant',
  },
  warningLevel: {
    alias: 'mahnstuffe',
  },
  note: {
    alias: 'notiz',
  },
  objGrId: {
    alias: 'objGrCode',
  },
  positionText: {
    alias: 'positionstext',
  },
  projectId: {
    alias: 'projektCode',
  },
  netValue: {
    alias: 'rBetrag',
  },
  rAmountCreated: {
    alias: 'rBetragErstellt',
  },
  rAmountForeign: {
    alias: 'rBetragFremd',
  },
  rLedgerAccountTotal: {
    alias: 'rESachkGesamt',
  },
  valueVat: {
    alias: 'rMwst',
  },
  rVatCreated: {
    alias: 'rMwstErstellt',
  },
  rNetCreated: {
    alias: 'rNettoErstellt',
  },
  invoiceNumber: {
    alias: 'rNummer',
  },
  originalInvoiceNumber: {
    alias: 'rNummerbeiLieferant',
  },
  reference: {
    alias: 'referenz',
  },
  travelExpensesId: {
    alias: 'reisekostenabrechnung',
  },
  businessPartnerId: {
    alias: 'sDObjMemberCode',
  },
  deductionDiscount: {
    alias: 'skonto',
  },
  discount2: {
    alias: 'skonto2',
  },
  discount2Date: {
    alias: 'skonto2Datum',
  },
  discount2Days: {
    alias: 'skonto2Tg',
  },
  discountDate: {
    alias: 'skontoDatum',
  },
  discountPerCent: {
    alias: 'skontoProzent',
  },
  discountDays: {
    alias: 'skontoTg',
  },
  blockedByUserId: {
    alias: 'sperrungBcode',
  },
  statusId: {
    alias: 'statusCode',
  },
  cancellationSum: {
    alias: 'stornSumme',
  },
  valueNotPayed: {
    alias: 'summe',
  },
  templateName: {
    alias: 'templatename',
  },
  tmpSkonto: {
    alias: 'tmpSkonto',
  },
  originRelationSum: {
    alias: 'ursprungBezSumme',
  },
  originVat: {
    alias: 'ursprungMwst',
  },
  originRAmount: {
    alias: 'ursprungRBetrag',
  },
  calculatedCode: {
    alias: 'verrechnetCode',
  },
  currencyId: {
    alias: 'waehrungCode',
  },
  reoccuring: {
    alias: 'wiederkehrend',
  },
  paymentId: {
    alias: 'zahlungsCode',
  },
  paymentKind: {
    alias: 'zahlungsart',
    entity: Entities.paymentKind,
  },
  approvedByUser: {
    alias: 'genehmigungDurchBenutzer',
    entity: Entities.user,
  },
  currency: {
    alias: 'waehrung',
    entity: Entities.currency,
  },
  insertTime: {
    alias: 'insertTime',
  },
  updateTime: {
    alias: 'updateTime',
  },
  receipts: {
    alias: 'belege',
    entity: Entities.file,
  },
  bankAccount: {
    alias: 'bankverbindung',
    entity: Entities.bankDetails,
  },
  releasedByUser: {
    alias: 'freigabeDurchBenutzer',
    entity: Entities.user,
  },
  inboundDeliveryNotes: {
    alias: 'eingangslieferscheine',
    entity: Entities.inboundDeliveryNote,
  },
  orders: {
    alias: 'bestellungen',
    entity: Entities.order,
  },
  blockedByUser: {
    alias: 'blockedByUser',
    entity: Entities.user,
  },
  sumValues: {
    alias: 'sumValues',
    entity: Entities.sumValues,
  },
  paymentTermDays: {
    alias: 'paymentTermDays',
  },
  createdByUserCode: {
    alias: 'createdByUserCode',
  },
  createdByUser: {
    alias: 'createdByUser',
    entity: Entities.user,
  },
  isPayed: {
    alias: 'paid',
  },
  payments: {
    alias: 'payments',
    entity: Entities.inboundInvoicePayment,
  },
  remainingAmount: {
    alias: 'remainingAmount',
  },
  grossAmount: {
    alias: 'grossAmount',
  },
  project: {
    alias: 'projekt',
    entity: Entities.project,
  },
  expectedNumber: {
    alias: 'expectedNumber',
  },
  favoriteItem: {
    alias: 'favoriteItem',
    entity: Entities.favoriteItem,
  },
  __typename: {
    alias: '__typename',
  },
};

export const inboundInvoiceEntityDefinition: EntitiyDefinition<InboundInvoice> =
  {
    local: {},
    remote: {
      queryName: 'getEingangsrechnung',
      fragmentName: 'Eingangsrechnung',
      withPaginationWrapper: true,
      mutations: {
        upsert: {
          mutationName: 'upsertIncomingInvoiceLedger',
          args: [
            { name: 'input', type: 'InputEingangsrechnung!' },
            { name: 'relations', type: 'InputReRelation' },
            { name: 'drySave', type: 'Boolean' },
          ],
        },
      },
      params: [
        { name: 'querySize', type: 'Int' },
        { name: 'queryPage', type: 'Int' },
        { name: 'querySortOrder', type: 'SortOrderStyle' },
        { name: 'querySortBy', type: 'String' },
        { name: 'querySortByEx', type: '[SortByPair]' },
        { name: 'filter', type: 'String' },
        { name: 'addFavSort', type: 'Boolean' },
        { name: 'onlyFavItems', type: 'Boolean' },
      ],
    },
    fieldDefinitions: fields,
  };
